export const MESSAGE_COUNT_POLL_INTERVAL = 30000;

export const CLIENT_ROLL_ID = 0;